import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-sm text-neutral-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: "/admin" }} />;
  if (!user.is_admin) return <Navigate to="/" replace />;
  return children;
}
